import {
  Button,
  cellStyles4,
  Chip,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { TextWithIcon } from '@HomaHealth/ui-component-library';
import roverTheme, {
  patientAccessTheme,
} from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import { Grid, Tooltip } from '@mui/material';
import moment from 'moment';
import componentConstants from '../messages/componentConstants';
import {
  EmployerGroupResponseData,
  IEmployerGroupResponseData,
} from '../../pages/HomePage';
import properties from '../properties';
import axios from 'axios';
import { formatTotalEnrolled } from './summaryReportHelper';
import HighToLow from '../../_components/atoms/Icons/HighToLow';
import LowToHigh from '../../_components/atoms/Icons/LowToHigh';
import { messages } from '../messages/homepagemessages';
import { ComplianceAssuranceType } from './contractAIQHelper';
import { NotificationCardProps } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/NotificationCard';
import { getTagProperties } from './notificationHelpers';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  QuickLinkGroup,
  QuickLinkItem,
  UserQuickLinkOverride,
} from '../../_components/molecules/HomeQuickLinks';
import { TabItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/CustomiseTabs';
import { truncateString } from './riskPatientDetailsHelper';

export interface EmployerGroup {
  id?: string;
  employer_group_name: string;
  risk_status: string;
  total_enrolles: number;
  pmpm: number;
  total_cost: string;
  start_month: string;
  start_year: string;
  end_month: string;
  end_year: string;
  v?: number;
}

const dropDownMenuItemsValues = [
  {
    text: (
      <TextWithIcon
        iconSrc={<HighToLow />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {messages.TABLE_SORT_PROPS[0]}
          </Typography>
        }
      />
    ),
    actionType: 'descendingSorting',
  },
  {
    text: (
      <TextWithIcon
        iconSrc={<LowToHigh />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {messages.TABLE_SORT_PROPS[1]}
          </Typography>
        }
      />
    ),
    actionType: 'ascendingSorting',
  },
];

const dropDownMenuItemsAlphabets = [
  {
    text: (
      <TextWithIcon
        iconSrc={<HighToLow />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {messages.TABLE_ALPHABET_SORT[0]}
          </Typography>
        }
      />
    ),
    actionType: 'descendingSorting',
  },
  {
    text: (
      <TextWithIcon
        iconSrc={<LowToHigh />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {messages.TABLE_ALPHABET_SORT[1]}
          </Typography>
        }
      />
    ),
    actionType: 'ascendingSorting',
  },
];

export const individualGroupsTableColumns: Columns[] = [
  {
    name: 'Group Name',
    sortColumnName: 'employer_group_name',
    align: 'left',
    cellStyles: cellStyles4,
    width: '190px',
    showEllipsis: true,
    ellipsisWidth: '170px',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Employees',
    align: 'left',
    cellStyles: cellStyles4,
    width: '175px',
    sortColumnName: 'total_enrolles',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Renewal Month',
    align: 'left',
    cellStyles: cellStyles4,
    width: '150px',
  },
  {
    name: 'Plan Type',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
  },
  {
    name: 'Location',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
  },
];

export const individualGroupsContractColumns: Columns[] = [
  {
    name: 'GROUP NAME',
    align: 'left',
    cellStyles: cellStyles4,
    showEllipsis: true,
    ellipsisWidth: '170px',
    width: '250px',
    sortColumnName: 'employer_group_name',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'TPA',
    align: 'left',
    cellStyles: cellStyles4,
    width: '140px',
    showEllipsis: true,
    ellipsisWidth: '120px',
    sortColumnName: 'TPA',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'PBM',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
    showEllipsis: true,
    ellipsisWidth: '120px',
    sortColumnName: 'PBM',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'STOP LOSS CARRIER',
    align: 'left',
    cellStyles: cellStyles4,
    width: '150px',
    showEllipsis: true,
    ellipsisWidth: '120px',
    sortColumnName: 'stoploss_carrier',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'NETWORK',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
    showEllipsis: true,
    ellipsisWidth: '120px',
    showThisColumn: true,
    sortColumnName: 'network',
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
];

export const getDotColor = (chiptype: string) => {
  switch (chiptype) {
    case 'Relatively Healthy':
      return '#727E9C';
    case 'Low Risk':
      return '#506AB1';
    case 'Medium Risk':
      return '#BA4747';
    case 'Needs Attention':
      return '#A24F4F';
    case 'High Risk':
      return '#9D6A13';
    default:
      return '#9D6A13';
  }
};
export const getMonthNumber = (month: string) => {
  switch (month) {
    case 'Jan':
      return 0;
    case 'Feb':
      return 1;
    case 'Mar':
      return 2;
    case 'Apr':
      return 3;
    case 'May':
      return 4;
    case 'Jun':
      return 5;
    case 'Jul':
      return 6;
    case 'Aug':
      return 7;
    case 'Sep':
      return 8;
    case 'Oct':
      return 9;
    case 'Nov':
      return 10;
    case 'Dec':
      return 11;
    default:
      return 0;
  }
};
export const formatStartDate = (year: number, month: string) => {
  const monthNumber = getMonthNumber(month);
  return moment([year, monthNumber]).subtract(11, 'months').format('MMM YYYY');
};
export const formatEndDate = (year: number, month: string) => {
  const monthNumber = getMonthNumber(month);
  return moment([year, monthNumber]).format('MMM YYYY');
};
export const getEachChip = (
  textcolor: string,
  label: string,
  bgColor: string,
  borderColor: string,
) => {
  return (
    <Chip
      label={
        <Typography
          fontSize="12px"
          lineHeight="15px"
          fontType="medium"
          textColor={textcolor}
        >
          {label}
        </Typography>
      }
      backgroundColor={bgColor}
      border={borderColor}
      borderRadius="4px"
      padding="5px 8px"
      height="25px"
    />
  );
};
export const formatChipComponent = (chipType: string) => {
  switch (chipType) {
    case 'Relatively Healthy':
      return getEachChip(
        '#727E9C',
        componentConstants.PAGES.HOMEPAGE_CHIPS.RELATIVELY_HEALTHY,
        '#F7FAFF',
        '0.5px solid #727E9C',
      );
    case 'Low Risk':
      return getEachChip(
        '#506AB1',
        componentConstants.PAGES.HOMEPAGE_CHIPS.LOW_RISK,
        '#EEF1FB',
        '0.5px solid #506AB1',
      );
    case 'Medium Risk':
      return getEachChip(
        '#BA4747',
        componentConstants.PAGES.HOMEPAGE_CHIPS.MEDIUM_RISK,
        '#FBEEEE',
        '0.5px solid #BA4747',
      );
    case 'Needs Attention':
      return getEachChip(
        '#A24F4F',
        componentConstants.PAGES.HOMEPAGE_CHIPS.NEEDS_ATTENTION,
        '#FBEEEE',
        ' 0.5px solid #A24F4F',
      );
    case 'High Risk':
      return getEachChip(
        '#9D6A13',
        componentConstants.PAGES.HOMEPAGE_CHIPS.HIGH_RISK,
        '#FBF6EE',
        '0.5px solid #9D6A13',
      );
    default:
      return chipType;
  }
};

export const CustomDashboardsTopRightItem = ({
  text,
  icon,
  handleOnClick,
}: any) => {
  return (
    <Grid
      container
      sx={{
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        style={{
          padding: '10px 12px 10px 12px',
          height: '35px',
          border: `1px solid ${patientAccessTheme.palette.primary[500]}`,
          borderRadius: '4px',
          textTransform: 'none',
          fontSize: '14px',
          lineHeight: '17px',
          fontWeight: 500,
        }}
        variant="outlined"
        color="primary"
        width="140px"
        onClick={handleOnClick}
        startIcon={<div style={{ height: '16px', width: '16px' }}>{icon}</div>}
        label={
          <Typography
            style={{
              width: '109px',
              fontSize: '14px',
              lineHeight: '25px',
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 400,
            }}
          >
            {text}
          </Typography>
        }
      />
    </Grid>
  );
};

export const formatSubtitle = (
  subtitle: string,
  startDate: string,
  middleString: string,
  endDate: string,
) => {
  return (
    <Grid container direction="row">
      <Grid>
        <Typography
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          fontSize="14px"
          fontType="regular"
          lineHeight="16.49px"
        >
          {subtitle}
        </Typography>
      </Grid>
      <Grid style={{ marginInlineStart: '5px' }}>
        <Typography
          textColor={patientAccessTheme.palette.text.highemphasis}
          fontSize="14px"
          fontType="medium"
          lineHeight="16.49px"
        >
          {startDate + middleString + endDate}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const getMediumEmphasisText = (label: string, isTitle?: boolean) => {
  return (
    <Typography
      fontSize={isTitle ? '18px' : '12px'}
      lineHeight="24px"
      fontType={isTitle ? 'semiBold' : 'regular'}
      fontFamily="Inter"
      textColor={patientAccessTheme.palette.text.mediumemphasis}
      display="inline"
    >
      {label}
    </Typography>
  );
};

export const getHighEmphasisText = (
  label: string | number,
  isTitle?: boolean,
) => {
  return (
    <Typography
      fontSize={isTitle ? '18px' : '12px'}
      lineHeight="24px"
      fontType="semiBold"
      fontFamily="Inter"
      textColor={patientAccessTheme.palette.text.highemphasis}
      display="inline"
    >
      {label}
    </Typography>
  );
};
export const updateEmployerGroupToArray = (
  item: IEmployerGroupResponseData,
) => {
  const eg: any[] = [item.eg_nid];
  const egName: any[] = [item.employer_group_name];
  const employerGroupResponseData: IEmployerGroupResponseData = {
    _id: item._id,
    risk_status: item.risk_status,
    eg_nid: eg,
    employer_group_name: egName,
    status: item.status,
    plan_start_month: item.plan_start_month,
    plan_end_month: item.plan_end_month,
    recent_plan_year: item.recent_plan_year,
    start_month: item.start_month,
    start_year: item.start_year,
    end_month: item.end_month,
    end_year: item.end_year,
    total_enrolles: item.total_enrolles,
    pmpm: item.pmpm,
    total_cost: item.total_cost,
    organization: item.organization,
    assigned_to: item.assigned_to,
    __v: item.__v,
    last_updated: item.last_updated,
    sic_code: item.sic_code,
    industry_type: item.industry_type,
    state: item.state,
    admin_and_premium_cost: item.admin_and_premium_cost,
    max_claim_date: item.max_claim_date,
    min_claim_date: item.min_claim_date,
    max_incurred_date: item.max_incurred_date,
    min_incurred_date: item.min_incurred_date,
    care_navigation_id: item.care_navigation_id,
    network_indicator_list: item.network_indicator_list,
    is_claims_present: item?.is_claims_present,
  };
  return employerGroupResponseData;
};

export const getTotalEnrolled = async (
  requestBody: any,
  setTotalEnrolled: any,
  setLoading?: any,
) => {
  await axios
    .post(properties.aiqBaseUrl + properties.summaryBaseUrl, requestBody)
    .then((res) => {
      if (res?.status === 200) {
        setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
      }
    })
    .catch((error) => {
      return error;
    });
  setLoading(false);
};

export interface ICustomQueriesTypesAndFeatures {
  type: string;
  features: string[];
  url: string;
}

export const formatCustomQueriesTypesAndFeaturesResponseData = (
  data: ICustomQueriesTypesAndFeatures[],
) => {
  const formattedData: any = {};
  data.forEach((item) => {
    formattedData[item.type] = {
      features: item.features,
      url: item.url,
    };
  });
  return formattedData;
};

export const getEmployerGroupsNames = (
  employerGroupList: IEmployerGroupResponseData[],
  complianceAssurancesGroups: ComplianceAssuranceType[],
) => {
  const employerGroups = employerGroupList.map((item) =>
    Array.isArray(item.employer_group_name)
      ? item.employer_group_name[0]
      : item.employer_group_name,
  );

  const complianceGroups = complianceAssurancesGroups.map((item) => item.group);

  return Array.from(new Set([...employerGroups, ...complianceGroups]));
};

export const getEmployerItem = (
  employerGroupList: EmployerGroupResponseData[],
  employerName: string,
) => {
  if (!employerGroupList || !employerName) {
    return undefined;
  }

  return employerGroupList.find((item) => {
    const groupName = Array.isArray(item.employer_group_name)
      ? item.employer_group_name[0]
      : item.employer_group_name;

    return (
      groupName?.toLowerCase().trim() === employerName.toLowerCase().trim()
    );
  });
};

export const formatEmployerGroupNameForTable = (
  name: string[],
  item: IEmployerGroupResponseData,
  handleEmployerGroupCardClick: any,
  defaultRoute: string,
) => {
  return (
    <div
      onClick={() =>
        handleEmployerGroupCardClick(
          item,
          defaultRoute,
          formatStartDate(item.recent_plan_year, item.plan_end_month),
          formatEndDate(item.recent_plan_year, item.plan_end_month),
        )
      }
    >
      <Typography
        fontSize="14px"
        lineHeight="28px"
        textColor={patientAccessTheme.palette.primary.main}
        fontType="medium"
        styleProps={{
          textDecoration: 'underline dashed',
          textUnderlineOffset: '6px',
          cursor: 'pointer',
        }}
      >
        {name}
      </Typography>
    </div>
  );
};

export const formatEmployerGroupLocation = (location: string) => {
  const locationString = Array.isArray(location)
    ? location.join(', ')
    : location;
  return (
    <Tooltip
      disableFocusListener
      placement="bottom-start"
      title={<Typography fontSize="12px">{locationString}</Typography>}
      arrow
    >
      <Grid>
        <Typography
          fontSize="14px"
          fontType="medium"
          noWrap
          styleProps={{
            whiteSpace: 'nowrap',
            width: '133px',
          }}
        >
          {truncateString(locationString, 20)}
        </Typography>
      </Grid>
    </Tooltip>
  );
};
export const formatGroupsTableData = (
  employerGroupList: IEmployerGroupResponseData[],
  handleEmployerGroupCardClick: any,
  defaultRoute: string,
) => {
  const rowdata: any[] = [];
  employerGroupList?.forEach((item) => {
    const updatedItem: IEmployerGroupResponseData = updateEmployerGroupToArray(
      item,
    );
    const row: any = [];

    row.push(
      formatEmployerGroupNameForTable(
        item.employer_group_name,
        updatedItem,
        handleEmployerGroupCardClick,
        defaultRoute,
      ),
    );
    row.push(item.total_enrolles);
    row.push(item.renewal_month || '-');
    row.push(item.plan_type || '-');
    row.push(formatEmployerGroupLocation(item?.location || '-'));
    rowdata.push(row);
  });
  return rowdata;
};

export const getEmployerTableData = (
  employerGroupList: IEmployerGroupResponseData[],
  currentPage: number,
  pageSize: number,
) => {
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return employerGroupList.slice(startIndex, endIndex);
};

export const getInProgressGroups = (
  employerGroupList: IEmployerGroupResponseData[],
  currentPage: number,
  pageSize: number,
) => {
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const progressGroups: number[] = [];
  employerGroupList
    .slice(startIndex, endIndex)
    .map((item: any, index: number) => {
      if (item.status === 'inprogress') {
        progressGroups.push(index);
      }
    });
  return progressGroups;
};
const getDynamicTitle = (insightsTitle: string, isPlural: boolean): string => {
  if (insightsTitle.includes('Insight')) {
    return isPlural ? 'Insights discovered' : 'Insight discovered';
  }
  if (insightsTitle.includes('Task')) {
    return isPlural ? 'Suggested Tasks' : 'Suggested Task';
  }
  return insightsTitle;
};

export const processNotifications = (
  rawData: any[],
): NotificationCardProps[] => {
  return rawData.map(
    (item: any): NotificationCardProps => {
      const {
        tagColor,
        tagIcons,
        insightsTitle,
        cardTitleColor,
        cardStyle,
        cardIcon,
      } = getTagProperties(item.tag);

      const isPlural = item.analysis_type?.length > 1;
      const dynamicTitle = getDynamicTitle(insightsTitle, isPlural);

      return {
        eg_nid: item.eg_nid,
        notification: item.notification,
        tag: item.tag,
        date: moment.utc(item?.createdAt).format('MMMM D, YYYY'),
        analysis_type: item.analysis_type.map((a: any) => a.title ?? a.name),
        tagIcons,
        tagColor,
        insightsTitle: dynamicTitle,
        cardTitleColor,
        cardStyle,
        cardIcon,
        handleOnclickInsights: () => {},
      };
    },
  );
};

export function normalizeQuickLinks(
  rawGroups: {
    title: string;
    links: Omit<QuickLinkItem, 'quickLinkvisibility' | 'quickLinkIndex'>[];
  }[],
  hiddenLinks: string[],
  combinedScreensAccess: string[],
  isAdmin: string,
): QuickLinkGroup[] {
  let globalIndex = 0;
  return rawGroups.map((group) => ({
    title: group.title,
    links: group.links.map((link) => {
      const accessRoute = link.SCREEN_NAME;
      return {
        ...link,
        quickLinkvisibility: !hiddenLinks.includes(link.TITLE),
        quickLinkIndex: globalIndex++,
        DISABLED:
          isAdmin === 'super_admin'
            ? false
            : !combinedScreensAccess.includes(accessRoute),
      };
    }),
  }));
}

export const mergeQuickLinks = (
  defaults: QuickLinkGroup[],
  userOverrides: UserQuickLinkOverride[],
): QuickLinkGroup[] => {
  const overrideMap = new Map(userOverrides.map((o) => [o.quickLinkName, o]));

  return defaults.map((group) => ({
    ...group,
    links: group.links.map((link) => {
      const override = overrideMap.get(link.TITLE);
      return override ? { ...link, ...override } : link;
    }),
  }));
};

export function generateTabs(quickLinks: QuickLinkGroup[]): TabItem[] {
  return quickLinks
    .flatMap((group) =>
      group.links.map((link) => ({
        id: link.TITLE,
        label: link.TITLE,
        visible: link.quickLinkvisibility,
        quickLinkIndex: link.quickLinkIndex,
      })),
    )
    .sort((a, b) => a.quickLinkIndex - b.quickLinkIndex);
}
export function extractOverridesFromTabs(
  tabs: TabItem[],
): UserQuickLinkOverride[] {
  return tabs.map((tab, index) => ({
    quickLinkIndex: index,
    quickLinkName: tab.label,
    quickLinkvisibility: tab.visible,
  }));
}

export const createEmployerGroupData = (
  eg_nid: string,
  employer_name: string,
): IEmployerGroupResponseData => ({
  _id: '',
  risk_status: '',
  status: '',
  plan_start_month: '',
  plan_end_month: '',
  recent_plan_year: 0,
  start_month: '',
  start_year: 0,
  end_month: '',
  end_year: 0,
  total_enrolles: 0,
  pmpm: 0,
  total_cost: 0,
  organization: '',
  assigned_to: '',
  __v: 0,
  last_updated: '',
  sic_code: '',
  industry_type: '',
  state: '',
  admin_and_premium_cost: [],
  max_claim_date: '',
  min_claim_date: '',
  max_incurred_date: '',
  min_incurred_date: '',
  eg_nid: [eg_nid],
  employer_group_name: [employer_name],
  care_navigation_id: '',
  network_indicator_list: [],
});
